SA.ArrowMenu2 = class {
    get tpl() {
        return [
            '<svg class="sa-arrow-menu-2-close-button"><use href="#sa-icon-close"></use></svg>',
            '<div class="sa-arrow-menu-2-caption"></div>',
            '<ul class="sa-arrow-menu-2-list"></ul>'
        ].join('');
    }

    constructor({caption, items, placement, target}) {
        this.popup = new SA.ArrowPopup({content: this.createContentEl({caption, items}), placement, target});
    }

    createContentEl({caption, items}) {
        var el = document.createElement('div');

        el.classList.add('sa-arrow-menu-2');
        el.innerHTML = this.tpl;
        el.querySelector('.sa-arrow-menu-2-caption').textContent = caption;
        el.querySelector('.sa-arrow-menu-2-close-button').addEventListener('click', this.destroy.bind(this));

        items.forEach(item => el.querySelector('.sa-arrow-menu-2-list').appendChild(this.createItemEl(item)));

        return el;
    }

    createItemEl(item) {
        var itemEl = document.createElement('li');

        itemEl.classList.add('sa-arrow-menu-2-list-item');
        itemEl.innerHTML = item.html;

        itemEl.addEventListener('click', () => {
            this.popup.fireEvent(new CustomEvent('item:click', {detail: {item}}));

            this.destroy();
        });

        return itemEl;
    }

    destroy() {
        this.popup.destroy();
    }

    on(type, listener, scope) {
        this.popup.on(type, listener, scope);
    }
};